import FieldsWidget from './FieldsWidget';
import { bindActionCreators, Dispatch } from 'redux';
import { connect } from 'react-redux';
import { actions as lookupActions, selectors as lookupSelectors } from 'ducks/lookup';
import { selectors as staffSelectors } from 'ducks/staff';
import { IApplicationState } from 'ducks/reducers';
import { selectors as customerSelectors } from 'ducks/customer';
import { selectors as productSelectors } from 'ducks/SearchLookUp/productLookup';
import { selectors as pickSlipSelectors } from 'ducks/pickSlips/pickSlipTransaction';

const mapStateToProps = (state: IApplicationState) => ({
  lookUpOptions: lookupSelectors.options(state) || [],
  selectedCustomer: customerSelectors.selected(state)?.CustomerId,
  selectedProduct: productSelectors.selected(state)?.ProductId,
  selectedPickSlip: pickSlipSelectors.selected(state),
  defaultWarehouseEntity: staffSelectors.defaultWarehouseEntity(state),
  defaultSalesEntity: staffSelectors.defaultSalesEntity(state),
});

const mapDispatchToProps = (dispatch: Dispatch) => bindActionCreators(
  {
    fetchLookupOptions: lookupActions.fetchData,
  },
  dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(FieldsWidget);
